<template>
  <section class='custom-dialog-container'>
    <el-dialog
      title="快速采集"
      width="750px"
      v-loading="loading"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
    >
      <el-input v-model="src" placeholder="请输入网址"></el-input>
      <el-button type="primary" @click="handleClickSrc">访问</el-button>
      <div class="iframe-wrap">
        <iframe
          id="myIframe"
          :src="src"
          frameborder="0"
          security="restricted"
          @load='iframeLoad'></iframe>
      </div>
          <!-- security="restricted"
          sandbox="" -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleConfirm">仅保存任务</el-button>
        <el-button size="small" type="primary" @click="handleCollect">开始采集</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
export default {
  name: 'CustomDialog',
  data () {
    return {
      loading: false,
      dialogVisible: false,
      src: '/test2.html'
    }
  },
  methods: {
    showDialog () {
      this.dialogVisible = true
    },
    handleCancel () {
      this.dialogVisible = false
    },
    handleClickSrc () {
    },
    handleConfirm () {
    },
    handleCollect () {
    },
    onClick (e) {
      e.stopPropagation()
      e.preventDefault()
      // 获取xpath
      var readXPath = function f (element) {
        // /html/body/div[3]/div[1]/div[1]/div[2]/p[2]
        const body = window.document.getElementById('myIframe').contentWindow.document.body
        if (element.id !== '') { // 判断id属性，如果这个元素有id，则显 示//*[@id="xPath"]  形式内容
          // eslint-disable-next-line no-useless-escape
          return '//*[@id=\"' + element.id + '\"]'
        }
        // 这里需要需要主要字符串转译问题，可参考js 动态生成html时字符串和变量转译（注意引号的作用）
        if (element === body) { // 递归到body处，结束递归
          return '/html/' + element.tagName.toLowerCase()
        }
        var ix = 1 // 在nodelist中的位置，且每次点击初始化
        var siblings = element.parentNode.childNodes// 同级的子元素

        for (var i = 0, l = siblings.length; i < l; i++) {
          var sibling = siblings[i]
          // 如果这个元素是siblings数组中的元素，则执行递归操作
          if (sibling === element) {
            return f(element.parentNode) + '/' + element.tagName.toLowerCase() + '[' + (ix) + ']'
            // 如果不符合，判断是否是element元素，并且是否是相同元素，如果是相同的就开始累加
          } else if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
            ix++
          }
        }
      }
      const xpath = readXPath(e.target)
      console.log(xpath)
    },
    onMouseMove (e) {
      e.stopPropagation()
      e.target.style.backgroundColor = 'yellow'
    },
    onMouseleave (e) {
      e.stopPropagation()
      e.target.style.backgroundColor = ''
    },
    iframeLoad (e) {
      const iframe = window.document.getElementById('myIframe')
      iframe.contentWindow.document.body.addEventListener('click', this.onClick)
      iframe.contentWindow.document.body.addEventListener('mousemove', this.onMouseMove)
      const that = this
      const registerEvent = function r (element) {
        if (element.nodeType === 1) {
          element.onmouseout = that.onMouseleave
          if (element.childNodes instanceof Array && element.childNodes.length) {
            for (var i = 0, l = element.childNodes.length; i < l; i++) {
              r(element.childNodes[i])
            }
          }
        }
      }
      registerEvent(iframe.contentWindow.document.body)
    }
  }
}
</script>
<style lang="scss">
.custom-dialog-container{
  .el-dialog{
    .iframe-wrap{
      margin-top: 20px;
      overflow: auto;
      height: 260px;
      border-radius: 4px;
      border: 1px solid #e8e8e8;

      iframe{
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
